export default "__VITE_ASSET__BZs5JpCT__"